<template>
  <div class='content'>
    <Header></Header>
    <div class="main-box">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
  name: '',
  data() {
    return {
      
    }
  },
  methods: {
    
  },
  created() {
    
  },
  components: {
    Header
  }
}
</script>
<style lang='less' scoped>

.content {
  display: flex;
  flex-direction: column;
}
  
</style>